export const Footer = () => {
  return (
    <footer className="mac-footer" data-testid="footer">
      <div className="mac-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="mac-logo-slot" data-testid="footer-logo-slot" style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
              <img src="https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/fo1ztu3b_Macaron.png" alt="The Macaron AI" className="mac-logo-mark" />
              THE MACARON AI
            </div>
            <p
              style={{
                marginTop: 10,
                fontFamily: "Inter, sans-serif",
                fontSize: 12,
                color: "rgba(255,255,255,0.55)",
              }}
            >
              © 2026 Givanko Inc. All rights reserved.
            </p>
          </div>

          <div
            className="md:text-right"
            style={{ fontFamily: "Inter, sans-serif", fontSize: 14, color: "var(--white)", lineHeight: 1.9 }}
          >
            <div>themacaron.ai</div>
            <div>hello@themacaron.ai</div>
            <div>NYC · SF</div>
          </div>
        </div>
      </div>
    </footer>
  );
};
